import { Smartphone } from "lucide-react";
import { Logo } from "@/components/common";

// Paste your store links here once the app is published.
export const APP_STORE_URL = "";
export const PLAY_STORE_URL = "";

const StoreBtn = ({ href, label, testId }) => href ? (
  <a href={href} target="_blank" rel="noreferrer" data-testid={testId}
    className="inline-flex items-center gap-2 bg-white text-stone-900 hover:bg-[#FF5C00] hover:text-white px-5 py-2.5 rounded-full text-sm font-semibold transition-colors">
    <Smartphone className="h-4 w-4" /> {label}
  </a>
) : (
  <span data-testid={testId} aria-disabled="true" title="Coming soon"
    className="inline-flex items-center gap-2 bg-white/10 text-white/70 border border-white/20 px-5 py-2.5 rounded-full text-sm font-semibold cursor-not-allowed">
    <Smartphone className="h-4 w-4" /> {label} <span className="font-mono text-[10px] uppercase tracking-widest text-orange-300">Soon</span>
  </span>
);

export const GetTheAppBanner = () => (
  <div data-testid="get-app-banner" className="rise relative overflow-hidden rounded-3xl bg-[#1C1917] text-white p-6 sm:p-8 text-left grain">
    <div className="absolute -top-20 -right-16 h-56 w-56 rounded-full bg-[#FF5C00]/30 blur-3xl" />
    <div className="relative flex flex-col sm:flex-row sm:items-center gap-5">
      <Logo className="h-14 w-14 shrink-0" />
      <div className="flex-1">
        <p className="font-display text-2xl font-black">Your ticket is in the app too</p>
        <p className="mt-1 text-sm text-stone-300">Log in to the Creator Series app with the same email to show your ticket at the door, get event updates and chat with the host.</p>
        <div className="mt-4 flex flex-wrap gap-3">
          <StoreBtn href={APP_STORE_URL} label="App Store" testId="get-app-ios" />
          <StoreBtn href={PLAY_STORE_URL} label="Google Play" testId="get-app-android" />
        </div>
      </div>
    </div>
  </div>
);
